import { useTheme, useMediaQuery } from "@pankod/refine-mui";

export const normalizeData = (data) => {
  // following code credits goes to roelbeerens see: https://forum.strapi.io/t/discussion-regarding-the-complex-response-structure-for-rest-graphql-developer-experience/13400/9
  const isObject = (data) =>
    Object.prototype.toString.call(data) === "[object Object]";

  const flatten = (data) => {
    if (!data.attributes) return data;

    return {
      id: data.id,
      ...data.attributes,
    };
  };

  if (Array.isArray(data)) {
    return data.map((item) => normalizeData(item));
  }

  if (isObject(data)) {
    if (Array.isArray(data.data)) {
      data = [...data.data];
    } else if (isObject(data.data)) {
      data = flatten({ ...data.data });
    } else if (data.data === null) {
      data = null;
    } else {
      data = flatten(data);
    }

    for (const key in data) {
      data[key] = normalizeData(data[key]);
    }

    return data;
  }

  return data;
};

export const updateFieldsWithRecordValues = (record, setValue) => {
  Object.keys(record).forEach((key) => {
    // if key is array or object, we update it
    if (
      record[key] &&
      (Array.isArray(record[key]) || typeof record[key] === "object")
    ) {
      // console.log("Updating", key);
      setValue(key, record[key]);
    }
  });
};

export const applyRecordToFields = (record, setValue) => {
  Object.keys(record).forEach((key) => {
    // console.log("Updating", key);
    setValue(key, record[key]);
  });
};

export const truncateString = (str, num) => {
  if (str.length <= num) {
    return str;
  }
  return str.slice(0, num) + "...";
};

export const useMobile = () => {
  const theme = useTheme();
  const lessThanMid = useMediaQuery(theme.breakpoints.down("md"));
  return true;
  return lessThanMid;
};
